<template>
  <v-text-field
    class="input-styles"
    :value="name"
    :rules="[requiredCheck]"
    @input="(val) => update(type, val)"
    :label="label()"
    height="48"
    placeholder=" "
    maxlength="200"
    minlength="2"
    outlined
    persistent-placeholder
    required
    :autofocus="autofocus"
  ></v-text-field>
</template>

<script>
export default {
  name: "NameInput",
  methods: {
    label() {
      const labels = {
        firstName: "First Name",
        lastName: "Last Name",
        name: "Full Name",
      };
      return labels[this.type];
    },
    requiredCheck(value) {
      const val = value && value.replace(/\s+/g, " ").trim();
      return (!!val && val.length > 1) || "Required.";
    },
  },
  props: { name: String, type: String, update: Function, autofocus: Boolean },
};
</script>
